/**
 * `CourseCard`'s boxes, shared with `CourseCardSkeleton` so the two cannot
 * drift: a skeleton built from the same classes is the same height at every
 * width. A `.ts` sibling so both component files export only a component.
 *
 * The card has no panel of its own (the pages revamp draws a course as a
 * 16:9 picture with its words under it, straight on the page). Heights, top
 * to bottom: the thumbnail (the card's width decides it), `pt-3`, the title
 * (one or two `text-h-m` lines, 24px each, clamped at two), `gap-1`, the meta
 * line (`text-body-xs`, 16px), `gap-1` + `pt-1`, the foot (24px — the price's
 * `text-h-s` line plus a little air, or the progress block's own height,
 * whichever a card draws). A one-line title is a line shorter than a
 * two-line one and the words under it sit just below it: the cards in a row
 * line up at the top, as the design draws them, not at the foot.
 */
export const CARD_BOX = 'group/card flex h-full flex-col'

export const CARD_BODY = 'flex flex-1 flex-col gap-1 pt-3'

export const CARD_FOOT = 'flex min-h-6 flex-wrap items-center gap-x-3 gap-y-2 pt-1'
